let wcpaPriceModulePromise;

export function wcpaPriceEvents() {
	const forms = document.querySelectorAll(".wcpa_form_outer");
	if (!forms.length) return;

	if (!wcpaPriceModulePromise) {
		wcpaPriceModulePromise = import("./wcpa-price.js");
	}

	wcpaPriceModulePromise
		.then(({ initWcpaPriceUpdates }) => {
			initWcpaPriceUpdates();
		})
		.catch((err) => {
			console.error("Failed to load WCPA pricing module:", err);
		});
}
